module.exports = __webpack_public_path__ + "src/assets/img/logo5.edbed56d.png";